module.exports = __webpack_public_path__ + "static/media/index_mooc_brian.a146cb5e.jpg";